// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"0456230b","886":"730e0deb"}[chunkId] + ".chunk.css";
};